var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag-icon{background-size:contain;background-position:50%;background-repeat:no-repeat;position:relative;display:inline-block;width:1.33333333em;line-height:1em}.flag-icon:before{content:\"\\A0\"}.flag-icon.gb{background-image:url(" + escape(require("../../../assets/flags/4x3/gb.svg")) + ")}.flag-icon.nl{background-image:url(" + escape(require("../../../assets/flags/4x3/nl.svg")) + ")}\n", ""]);

// exports
